import ContentLoader from 'react-content-loader';

import { ContentCardLoadingItem } from '../../../../core/components/organism/ContentCard/ContentCardLoadingItem';
import { useScreenSize } from '../../../../core/hooks/useScreenSize';
import { useWindowBreakpoints } from '../../../../core/hooks/useWindowBreakpoints';

interface iContentCardLoadingItemProps {
  itensCount: number;
}

function PastEventsListLoading({ itensCount }: iContentCardLoadingItemProps) {
  const screenSize = useScreenSize();
  const windowBreakpoinst = useWindowBreakpoints();
  const isMobile = screenSize <= windowBreakpoinst.md;

  return (
    <div>
      <ContentLoader
        viewBox={`0 0 1000 ${isMobile ? itensCount * 175 : itensCount * 125}`}
      >
        {Array.from(Array(itensCount).keys()).map((item) => (
          <ContentCardLoadingItem
            y={isMobile ? item * (94 + 70) : item * 94}
            isMobile={isMobile}
            key={item}
          />
        ))}
      </ContentLoader>
    </div>
  );
}

export { PastEventsListLoading };
